import React, { useMemo, useRef } from "react";

import Button from "devextreme-react/button";
import DataGrid, { Column, MasterDetail } from "devextreme-react/data-grid";
import Balancer from "react-wrap-balancer";

import { jurnalGoldSvgDataURL } from "@app/components/drawer/background";
import { useInsiderGate, useWindowDimensions } from "@app/contexts";
// import { triggerSync } from "@app/index";
import { useAppDispatch } from "@app/state";
import { useFxDispatch, useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import { selectChooserRepoItems } from "@app/statefx/selectors/drawer";
import { reloadApp } from "@app/statefx/xThunks/app";
import { cchSetCurrentPage } from "@app/statefx/xThunks/uiDrawer";
import "@app/style/dx.generic.catetory-chooser-compact.min.css";

import "./drawer.scss";
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
import { MenuDetail } from "./InsiderDrawerDetail";

type TCategoryPages = {
  id: number;
  name: string;
  parentId: number;
};
export const InsiderDrawerContent = () => {
  const shouldExpand = useRef(false);
  const sfxDispatch = useFxDispatch();
  const dispatch = useAppDispatch();
  const { height: drawerHeight } = useWindowDimensions();
  const theCatChooser = useFxSelector(schema.categoryChooser.select);
  const categoryChooser = useFxSelector(selectChooserRepoItems);
  const currentPage = useMemo(() => theCatChooser.currentPage, [theCatChooser]);
  const data = useInsiderGate();
  const { GROUP_NAME } = data?.userData || { GROUP_NAME: "" };

  const selectionChanged = (e: any) => {
    const { selectedRowKeys } = e;
    if (selectedRowKeys.length > 0) {
      sfxDispatch(cchSetCurrentPage(selectedRowKeys[0]));
    }
  };
  const rowExpanding = (e: any) => {
    e.cancel = !shouldExpand.current;
  };
  const onCellClick = (e: any) => {
    if (e.rowType === "data" && e.data.children.length > 0) {
      shouldExpand.current = true;
      if (!e.component.isRowExpanded(e.data.id)) {
        e.component.expandRow(e.data.id);
      }
    } else {
      shouldExpand.current = false;
    }
  };

  const onRowPreared = (e: any) => {
    if (e.rowElement !== null) {
      if (e.rowType === "data" && e.data.children.length === 0) {
        const commandExpand = e.rowElement.querySelector(".dx-command-expand");
        if (commandExpand?.firstChild instanceof Element) {
          commandExpand.firstChild.classList.remove("dx-datagrid-group-closed");
        }
      }
    }
  };

  const fullReloadInsider = () => {
    sfxDispatch(reloadApp());
  };

  const MenuDetailz = React.memo(({ data }: { data: any }) => (
    <MenuDetail data={data} />
  ));
  MenuDetailz.displayName = "MenuDetailz";
  return (
    <div
      id={"drawer-insider"}
      className={"svg-container 1"}
      style={{
        width: 144,
        height: drawerHeight || "auto",
        backgroundImage: jurnalGoldSvgDataURL,
        backgroundSize: "cover",
      }}
    >
      <DataGrid
        id={"categoryChooser"}
        className="dx-swatch-catetory-chooser"
        dataSource={categoryChooser}
        keyExpr={"id"}
        showBorders={false}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        showColumnHeaders={false}
        headerFilter={{ visible: false }}
        filterRow={{ visible: false }}
        hoverStateEnabled={true}
        selection={{ mode: "single" }}
        showRowLines={true}
        selectedRowKeys={[currentPage]}
        onSelectionChanged={selectionChanged}
        onRowExpanding={rowExpanding}
        onCellClick={onCellClick}
        onRowPrepared={onRowPreared}
      >
        <Column dataField={"name"} caption={"Categorie"} />
        <MasterDetail
          enabled={true}
          autoExpandAll={false}
          render={(e) => <MenuDetail data={e.data} />}
        />
      </DataGrid>
      <div className="footer">
        {/* column reverse  */}
        {/* we moved the exit to upper right corner */}
        <Button
          hint={"Jurnal Gold Insider"}
          stylingMode={"text"}
          icon={"refresh"}
          onClick={fullReloadInsider}
        />
        <div className="insider-subtitle">
          <Balancer>{GROUP_NAME}</Balancer>
        </div>
        <div className="insider-title">
          <div id={"jg-title"}>Jurnal Gold Insider</div>
        </div>
      </div>
    </div>
  );
};
/* -------------------------------------------------------------------------- */
